import Vue from 'vue';
import Router from 'vue-router';

import Home from '@/views/Home.vue';
import Match from '@/views/Match.vue';
import Matches from '@/views/Matches.vue';
import Team from '@/views/Team.vue';
import Teams from '@/views/Teams.vue';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/matches',
      name: 'matches',
      component: Matches,
    },
    {
      path: '/matches/:matchId',
      name: 'match',
      component: Match,
    },
    {
      path: '/teams',
      name: 'teams',
      component: Teams,
    },
    {
      path: '/teams/:teamId',
      name: 'team',
      component: Team,
    },
  ],
  mode: 'history',
  linkActiveClass: 'active',
  linkExactActiveClass: 'active',
});
